import { render, staticRenderFns } from "./ModalPublicPersonWarning.vue?vue&type=template&id=367b5fa5&scoped=true&"
import script from "./ModalPublicPersonWarning.vue?vue&type=script&lang=js&"
export * from "./ModalPublicPersonWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b5fa5",
  null
  
)

export default component.exports